//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectBody.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Patch",0,"SelectBodyList",0],[0,"PatchType",1,0],[1,"Product",0,"SelectBody",0],[0,"Subtract",1,0]],[[[],"ShowResult",{},0,0],[["selectedListString"],"AddListPartToPatchData",{},1,0]],[]];
SPLM.Tooling.SolidPatchBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SolidPatchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.SolidPatchBuilder.SolidPatchType = Object.freeze({
    "SolidPatch" : "SolidPatch", "LinkBody" : "LinkBody"});

export default SPLM;